
import { MemberSearchCompModule } from './../components/member-search/member-search-comp.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './auth/auth';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { MyApp } from './app.component';
import { InterceptorAuthProvider } from '../providers/interceptor-auth/interceptor-auth';
import { IonicStorageModule } from '@ionic/storage';
import { HeaderPopoverComponent } from '../components/shared/layout/app-header/header-popover/header-popover';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { UtilityProvider } from '../providers/utility/utility';
import { FacilityServicesProvider } from '../providers/facility-service/facility-service';
import { MomentModule } from 'angular2-moment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { OauthCodeFlowService } from '../providers/oauth-code-flow-service/oauth-code-flow-service';
import { ClientPlanServiceProvider } from '../providers/client-plan-service/client-plan-service';
import { IpAddressProvider } from '../providers/utility/ip-address/ip-address';
import { DateServiceProvider } from '../providers/utility/date-service/date-service'; 
import { EnvironmentServiceProvider } from './../providers/environment-service/environment-service';
// import { MemberSearchComponent } from '../components/member-search/member-search';
import { TextMaskModule } from 'angular2-text-mask'
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [
    MyApp,
    HeaderPopoverComponent,
    // MemberSearchComponent
  ],
  imports: [
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    BrowserAnimationsModule,
    AngularFontAwesomeModule,
    TextMaskModule,
    BrowserModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HeaderPopoverComponent,
    // MemberSearchComponent
  ],
  providers: [
    OauthCodeFlowService,
    CookieService,
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    InterceptorAuthProvider,
    UtilityProvider,
    ClientPlanServiceProvider,
    FacilityServicesProvider,
    IpAddressProvider,
    DateServiceProvider,
    FacilityServicesProvider,
    EnvironmentServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts